var EventEmitter, config, local, model, poet, tool;

EventEmitter = require('events').EventEmitter;

tool = require('./tool');

poet = require('./poet');

config = require('./config');

module.exports = model = new EventEmitter;

local = {
  slots: []
};

model.reset = function() {
  var h, i, index, ref, results, sizeX, sizeY, w;
  w = window.innerWidth;
  h = window.innerHeight;
  sizeX = Math.floor(w / config.width);
  sizeY = Math.floor(h / config.width);
  local.slots = [];
  results = [];
  for (index = i = 1, ref = sizeX; 1 <= ref ? i <= ref : i >= ref; index = 1 <= ref ? ++i : --i) {
    results.push(local.slots.push({
      wait: tool.random(sizeY),
      size: sizeY,
      drops: []
    }));
  }
  return results;
};

model.start = function() {
  var drop, i, j, len, len1, ref, ref1, slot;
  setTimeout((function() {
    return model.start();
  }), config.interval);
  ref = local.slots;
  for (i = 0, len = ref.length; i < len; i++) {
    slot = ref[i];
    slot.wait -= 1;
    ref1 = slot.drops;
    for (j = 0, len1 = ref1.length; j < len1; j++) {
      drop = ref1[j];
      drop.head += 1;
    }
    slot.drops = slot.drops.filter(function(drop) {
      return (drop.head - drop.length) <= slot.size;
    });
    if (slot.wait === 0) {
      drop = {
        text: poet.read(slot.size),
        length: tool.random(slot.size),
        head: 0
      };
      slot.drops.push(drop);
      slot.wait = drop.length + (tool.random(slot.size));
    }
  }
  return this.emit('change');
};

model.getSlots = function() {
  return local.slots;
};
